import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText, FDHeadlineText, FDStack,
} from '@facet-wealth/design';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { RoadmapGoalDetailOutcomeLayout } from './components/RoadmapGoalDetailActionLayout/RoadmapGoalDetailOutcomeLayout';
import { OutcomeSelector } from './components/OutcomeSelector';
import { RoadmapDeliverableStat } from './components/RoadmapGoalDetailActionLayout/components/RoadmapDeliverableStat';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: {
      variant: 'h1',
      weight: 'extraBold',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('progress', {
    _component: () => null,
  }, overrideReadOnly)
  .nameOverride('actionSectionTitle', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride(['goalAmount', 'goalDate'], {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'sm' },
  }, overrideReadOnly)
  .nameOverride(['totalAmount', 'targetDate'], {
    _component: () => RoadmapDeliverableStat,
  }, overrideReadOnly)
  .nameOverride('supportingMultipleGoalsDisclaimer', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'sm', align: 'center', color: 'textDisabled',
    },
  }, overrideReadOnly)
  .done();

const GoalDetailOutcomesSelectorContent = ({
  collection, resource, setIndex,
}) => {
  const outcomeOptions = collection.resources().list().map((res) => ({
    label: res.attr('title'),
    value: res.id(),
    icon: res.attr('icon'),
  }));

  const handleChange = (id) => {
    const index = collection.resources().list().findIndex((res) => res.id() === id);
    setIndex(index);
  };

  const selected = outcomeOptions.find((option) => option.value === resource.id()).value;

  return (
    <FDStack width={'100%'} justifyContent={'center'}>
      <FDStack direction={'column'} spacing={5} width={'100%'} maxWidth={600} alignItems={'center'}>
        <OutcomeSelector
          options={outcomeOptions}
          selected={selected}
          onChange={handleChange}
        />
        <MetaResourceRenderer
          layout={RoadmapGoalDetailOutcomeLayout}
          resource={resource}
          metaOverrideSet={metaOverrideSet}
        />
      </FDStack>
    </FDStack>
  );
};

GoalDetailOutcomesSelectorContent.propTypes = {};

export { GoalDetailOutcomesSelectorContent };
